export const CHARGING_PERMISSION = 'With Charging Permission';
